import React from 'react';
import { connect } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import UserMapSearch from '../../components/Search/UserMapSearch';
import client from '../../lib/apolloClient';

const UserMapSearchContainer = props => (
  <ApolloProvider client={client}>
    <UserMapSearch {...props} />
  </ApolloProvider>
);

export default connect()(UserMapSearchContainer);